import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const S_CORP_DESIGNATOR = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.sCorpDesignator.buyBox.bulletPoint1' },
          { title: 'productPage.sCorpDesignator.buyBox.bulletPoint2' },
          { title: 'productPage.sCorpDesignator.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.sCorpDesignator.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.sCorpDesignator.buyBox.veloCta.prompt',
          topic: 's-corp-election',
        },
        interactService: {
          service: 's_corp_designator',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/focused-business-outdoors.png',
      alt: 'productPage.sCorpDesignator.heroPicture.altText',
    },
    headline: 'productPage.sCorpDesignator.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.sCorpDesignator.page.subheader',
  },
  benefit: {
    title: 'productPage.sCorpDesignator.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg ',
        title: 'productPage.sCorpDesignator.valueProp.propTitle1',
        description: 'productPage.sCorpDesignator.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/moneyoffrounded.svg',
        title: 'productPage.sCorpDesignator.valueProp.propTitle2',
        description: 'productPage.sCorpDesignator.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.sCorpDesignator.valueProp.propTitle3',
        description: 'productPage.sCorpDesignator.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/helpoutlinerounded.svg',
    title: 'productPage.sCorpDesignator.topFeature.title',
    subheader: 'productPage.sCorpDesignator.topFeature.subheader',
    image: '/s2/raster/team-review-office.png',
    alt: 'productPage.sCorpDesignator.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.sCorpDesignator.howItWorks.title',
    items: [
      {
        title: 'productPage.sCorpDesignator.howItWorks.step1',
        description: 'productPage.sCorpDesignator.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.sCorpDesignator.howItWorks.step2',
        description: 'productPage.sCorpDesignator.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.sCorpDesignator.howItWorks.step3',
        description: 'productPage.sCorpDesignator.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.sCorpDesignator.howItWorks.step4',
        description: 'productPage.sCorpDesignator.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/construction-meeting-handshake.png',
    alt: 'productPage.sCorpDesignator.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.sCorpDesignator.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faq1',
        answer: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faq2',
        answer: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faq3',
        answer: 'productPage.sCorpDesignator.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.sCorpDesignator.needAssistance.title',
    getInTouch: 'productPage.sCorpDesignator.needAssistance.getInTouch',
    actions: 'productPage.sCorpDesignator.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.sCorpDesignator.buyBox.buttonLabel',
    }),
};
